import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";

import Dropzone from 'react-dropzone-uploader';
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import "jspdf-autotable";


import {
  getForum as onGetForum,
  addForum as onAddCompany,
  updateForum as onUpdateForum,
  deleteForum as onDeleteForum,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import axios from 'axios';
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Egzersiz | Subsea ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getIsActive, setIsActive] = useState(false);
  const [getFileName, setFileName] = useState(null);
  const [getCategoryID, setCategoryID] = useState(null);
  const [getFileType, setFileType] = useState(null);
  const [getFileNameMedia, setFileNameMedia] = useState(null);
  const [getCategory, setCategory] = useState([]);


  // State kısmına şunları ekleyin:
const [getFileNameEng, setFileNameEng] = useState(null); // image_eng için
const [getFileNameMediaEng, setFileNameMediaEng] = useState(null); // url_eng için
const [getFileTypeEng, setFileTypeEng] = useState(null); // İngilizce medya tipi

const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: (contactEdit && contactEdit.title) || "",
      title_eng: (contactEdit && contactEdit.title_eng) || "", // Eklendi
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Başlığı Giriniz"),
      title_eng: Yup.string().required("English Title is required"), // Eklendi
    }),
   onSubmit: values => {
  const payload = {
    Exercise_Category_ID: getCategoryID,
    title: values.title,
    title_eng: values.title_eng,
    image: getFileName,           // TR Görsel
    image_eng: getFileNameEng,    // EN Görsel
    url: getFileNameMedia,        // TR Ses/Video
    url_eng: getFileNameMediaEng, // EN Ses/Video
    type: "video",
    IsActive: getIsActive
  };

  if (isEdit) {
    dispatch(onUpdateForum({ ID: contactEdit.ID, ...payload }));
  } else {
    dispatch(onAddCompany(payload));
  }
  toggle();
},
  });


  const { users } = useSelector(state => ({
    users: state.contacts.forum,
  }));

  const [modal, setModal] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  // İngilizce Görsel (image_eng) için
const handleChangeStatusEng = ({ xhr }) => {
  if (xhr && xhr.readyState === 4) {
    const result = JSON.parse(xhr.response);
    setFileNameEng(result.file.filename);
  }
};

// İngilizce Medya (url_eng) için
const handleChangeStatusMediaEng = ({ file, xhr }) => {
  if (xhr && xhr.readyState === 4) {
    const result = JSON.parse(xhr.response);
    setFileNameMediaEng(result.file.filename);
    setFileTypeEng(file.type);
  }
};

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
    
       {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.image ? (
              <div className="avatar-xs">
                {cellProps.title != null ? <span className="avatar-title rounded-circle">
                  {cellProps.title.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>
                <img
                  className="rounded-circle avatar-xs"
                  src={'https://monoadmin.stechomeyazilim.info:8335/' + cellProps.image}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },

      {
        Header: "Başlık",
        accessor: "title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

        {
        Header: "Kategori",
        accessor: "Exercise_Category.categoryTitle",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

{
        Header: "Başlık (EN)",
        accessor: "title_eng",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

        {
        Header: "Aktiflik Durumu",
        accessor: "IsActive",
        filterable: true,
        Cell: cellProps => {
          return <Status {...cellProps} />;
        },
      },


      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">


              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );



  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }


  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://monoadmin.stechomeyazilim.info:8081/uploadfile', body }
  }

    const handleChangeStatusMedia = ({ file, xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameMedia(result.file.filename)
          setFileType(file.type);            // örnek: 'image/png', 'video/mp4'

        }
      }
    }
  }


  const handleChangeStatus = ({ file, xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)
        }
      }
    }
  }

    const _getAuthData = async () => {

    await axios.get(`https://monoadmin.stechomeyazilim.info:9199/getCategory/select/`)
      .then((res) => {
        setCategory(res.data)
      })
  }

    useEffect(() => {
    _getAuthData()
  }, [dispatch, getCategory]);


  useEffect(() => {

    if (users && !users.length) {
      dispatch(onGetForum());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };


const handleUserClick = (arg) => {
  const user = arg;
  setEditContact(user);
  setFileName(user.image);
  setFileNameEng(user.image_eng); // EN görsel yüklendi
  setFileNameMedia(user.url);
  setFileNameMediaEng(user.url_eng); // EN ses yüklendi
  setCategoryID(user.Exercise_Category_ID);
  setIsActive(user.IsActive);
  setIsEdit(true);
  toggle();
};



  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteForum(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setIsEdit(false);
    toggle();
  };




  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Egzersiz Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddBirbilen={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

             

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Egzersiz Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

              {/* Türkçe Başlık */}
<div className="mb-3">
  <Label className="form-label">Egzersiz Başlığı (TR)</Label>
  <Input
    name="title"
    type="text"
    placeholder="Egzersiz Başlığını Giriniz"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.title || ""}
    invalid={validation.touched.title && validation.errors.title ? true : false}
  />
  {validation.touched.title && validation.errors.title ? (
    <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
  ) : null}
</div>

{/* YENİ: İngilizce Başlık */}
<div className="mb-3">
  <Label className="form-label">Egzersiz Başlığı (EN)</Label>
  <Input
    name="title_eng"
    type="text"
    placeholder="Enter English Title"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.title_eng || ""}
    invalid={validation.touched.title_eng && validation.errors.title_eng ? true : false}
  />
  {validation.touched.title_eng && validation.errors.title_eng ? (
    <FormFeedback type="invalid">{validation.errors.title_eng}</FormFeedback>
  ) : null}
</div>

<div className="mb-3">
  <Label className="form-label">Egzersiz Kategorisi</Label>
  <select
    className="form-select"
    name="Exercise_Category_ID"
    value={getCategoryID || ""} // Boş gelirse "Kategori Seçiniz" görünür
    onChange={(e) => setCategoryID(e.target.value)}
    required
  >
    <option value="">Kategori Seçiniz</option>
    {getCategory && getCategory.length > 0 ? (
      getCategory.map((cat) => (
        <option key={cat.ID} value={cat.ID}>
          {cat.Category_Title || cat.title || cat.Name} {/* API'den dönen isme göre */}
        </option>
      ))
    ) : (
      <option disabled>Kategoriler Yükleniyor...</option>
    )}
  </select>
</div>                                     <div className="d-flex">
                              <label htmlFor="resume">Aktif Mi?</label>

                              <div className="square-switch">

                                <input
                                  type="checkbox"
                                  id="square-switch1"
                                  className="switch"
                                  defaultChecked={getIsActive}
                                  onChange={() =>
                                    setIsActive(!getIsActive)
                                  }
                                />
                                <label
                                  htmlFor="square-switch1"
                                  data-on-label="Aktif "
                                  data-off-label="Pasif"
                                />
                              </div>

                            </div>

                            <Row>
  {/* --- TÜRKÇE DOSYALAR (Mevcut olanlar) --- */}
  <Col md={6}>
    <Label className="mt-3">Görsel (TR)</Label>
    <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatus} maxFiles={1} accept="image/*" />
    {getFileName && <img src={'https://monoadmin.stechomeyazilim.info:8335/' + getFileName} className="avatar-md mt-2" />}
  </Col>

  <Col md={6}>
    <Label className="mt-3">Ses/Video (TR)</Label>
    <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusMedia} maxFiles={1} accept="audio/*,video/*" />
{getFileNameMedia && <span className="text-success">Dosya Yüklendi: {getFileNameMedia}</span>}
  </Col>

  {/* --- İNGİLİZCE DOSYALAR (YENİ EKLENENLER) --- */}
  <Col md={6}>
    <Label className="mt-3 text-primary">Görsel (EN)</Label>
    <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusEng} maxFiles={1} accept="image/*" />
    {getFileNameEng && <img src={'https://monoadmin.stechomeyazilim.info:8335/' + getFileNameEng} className="avatar-md mt-2" />}
  </Col>

  <Col md={6}>
    <Label className="mt-3 text-primary">Ses/Video (EN)</Label>
    <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusMediaEng} maxFiles={1} accept="audio/*,video/*" />
{getFileNameMediaEng && <span className="text-primary">EN File Uploaded: {getFileNameMediaEng}</span>}
  </Col>
</Row>



                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
